import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

/**
 * IconPlanetOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGxhbmV0LW9mZiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNy4wNDIgNy4wNTlhNyA3IDAgMCAwIDkuOTA4IDkuODltMS41ODEgLTIuNDI1YTcgNyAwIDAgMCAtOS4wNTcgLTkuMDU0IiAvPgogIDxwYXRoIGQ9Ik0zIDNsMTggMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/planet-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlanetOff = createReactComponent('outline', 'planet-off', 'PlanetOff', __iconNode);

export default IconPlanetOff;